import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { DownloadingResource, PolicyResponse } from '@anecdotes/shared-trust-center';
import { RegularDateFormatMMMdyyyy } from '@anecdotes/helpers';

@Component({
  selector: 'app-policy-side-panel',
  templateUrl: './policy-side-panel.component.html',
  styleUrls: ['./policy-side-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PolicySidePanelComponent {
  @HostBinding('class')
  private readonly classes = 'h-full';

  protected readonly DownloadingResource = DownloadingResource;
  protected readonly dateFormat = RegularDateFormatMMMdyyyy;

  @Input()
  policy: PolicyResponse;

  buildTranslationKey(relativeKey: string): string {
    return `trustCenter.${relativeKey}`;
  }
}
